import { render } from "./ConversationIcon.vue?vue&type=template&id=33dcd230&scoped=true"
import script from "./ConversationIcon.vue?vue&type=script&lang=js"
export * from "./ConversationIcon.vue?vue&type=script&lang=js"

import "./ConversationIcon.vue?vue&type=style&index=0&id=33dcd230&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dcd230"]])

export default __exports__